/*
 *
 * Subscription Plans actions
 *
 */
import {
  FETCH_SUBSCRIPTION_PLANS,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_FAILED,
} from 'containers/SubscriptionPlans/constants';

export function fetchSubscriptionPlans() {
  return {
    type: FETCH_SUBSCRIPTION_PLANS,
  };
}

export function fetchSubscriptionPlansSuccess(plans) {
  return {
    type: FETCH_SUBSCRIPTION_PLANS_SUCCESS,
    plans,
  };
}

export function fetchSubscriptionPlansError(error) {
  return {
    type: FETCH_SUBSCRIPTION_PLANS_FAILED,
    error,
  };
}
